import { SHIPMEMORABILIAORDER } from "./apiConfig";

export const endpoints = {
  baseURL: process.env.REACT_APP_API_URL ?? "/api/", // Please do not commit changes on this line , It will effect building script and not working with api on dev and quality .
  auth: {
    Login: "account/Login",
    ChangePassWord: "account/ChangePassword",
    ForgotPassword: "account/ForgotPassword",
    ResetPassword: "account/ResetPassword"
  },
  products: {
    GETALLPRODUCTS: "product/getproductlist",
    ADDNEWPRODUCT: "product/addnewproduct",
    DELETEPRODUCT: "product/deleteproduct",
    UPDATEPRODUCT: "product/updateproduct",
    GETPRODUCTURL: "Product/GetProductUrl",
    UPDATEPASTORDERPRODUCT: "order/UpdatePastOrderProduct",
    ALLOWREFUND: "order/AllowRefund",
    DECLINEREFUND: "order/DeclineRefund"
  },
  orders: {
    GETNEWORDERS: "order/GetOrderList",
    GETNEWORDERS_V2: "order/GetOrderList/V2",
    UPDATEORDERSTATUS: "order/UpdateOrderStatus",
    AcceptOrder: "order/AcceptOrder",
    UPDATENEWORDERFLAG: "order/UpdateNewOrderFlag",
    GETORDERLISTWITHSTATUS: "order/GetOrderListWithStatus",
    GETORDERLISTWITHSTATUS_V2: "order/V2/GetOrderListWithStatus",
    REPORTORDERISSUE: "order/ReportOrderIssue",
    SHIPORDER: "order/ShipOrder",
    SHIPMEMORABILIAORDER: "order/ShipMemorabiliaOrderToStore",
    SHIPMEMORABILIAORDERTOCUSTOMER: "order/ShipMemorabiliaFromSportStore",
    SHIPORDERCANCEL: "order/CancelShipment",
    REQUESTFEDEXPICKUP: "order/RequestFedExPickup",
    REQUESTMEMORABILIAFEDEXPICKUP: "order/RequestMemorabiliaFedExPickup",
    GETSERVICELABELS:"order/GetServiceLabels",
    CONFIRMSERVICELABELPRINT:"order/ConfirmServiceLabelPrint"
  },
  admin: {
    GETUSERS: "product/GetUsers",
    VIEWASUSER: "product/ViewAsUser",
},
};
